/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAddresses} from '../api'

 export const useQueryGetAddresses = createReactQueryHook('getAddresses', getAddresses)
